import "core-js/modules/es.array.includes.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import env from '@tencent/vft-common/env';
export default {
  data: function data() {
    return {
      isKidApp: env.isKidApp
    };
  },
  methods: {
    getGoldBelt: function getGoldBelt() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (env.isKidApp) {
                  _context.next = 3;
                  break;
                }

                _this.openPageWithAccount({
                  from: 'task',
                  ptag: 'xqednzw'
                });

                return _context.abrupt("return");

              case 3:
                _this.loading.show();

                _context.prev = 4;
                _context.next = 7;
                return _this.$store.dispatch('dailyAdd');

              case 7:
                _this.eventBus.$emit('dailyAddFinish');

                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](4);

                _this.loading.hide();

                if (![-102, -11, 8003].includes(_context.t0.ret)) {
                  _context.next = 17;
                  break;
                }

                _this.toast("\u767B\u5F55\u72B6\u6001\u51FA\u95EE\u9898\u5566\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55:(".concat(_context.t0.ret, ")"));

                setTimeout(function () {
                  _this.$openLogin();
                }, 500);
                return _context.abrupt("return");

              case 17:
                _this.toast("\u52A0\u725B\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5(".concat(_context.t0.ret || 0, ")"));

              case 18:
                _this.loading.hide();

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 10]]);
      }))();
    }
  }
};